import { render, staticRenderFns } from "./TjenesteDesign.vue?vue&type=template&id=139c2672&"
import script from "./TjenesteDesign.vue?vue&type=script&lang=ts&"
export * from "./TjenesteDesign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports